import Report1on1ByManager from "@apps/reporting/components/oneonone-report/1-on-1-by-manager";
import { currentOrganizationVar } from "@cache/cache";

const OneononeReport = () => {
  const organization = currentOrganizationVar();

  return (
    <div className="w-full px-8 bg-white pb-12">
      <Report1on1ByManager organization={organization} />
    </div>
  );
};

export default OneononeReport;
